import { render, staticRenderFns } from "./banckAccountInfoDetail.vue?vue&type=template&id=74c10c33&scoped=true"
import script from "./banckAccountInfoDetail.vue?vue&type=script&lang=js"
export * from "./banckAccountInfoDetail.vue?vue&type=script&lang=js"
import style0 from "./banckAccountInfoDetail.vue?vue&type=style&index=0&id=74c10c33&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74c10c33",
  null
  
)

export default component.exports